import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const currencyApi = createApi({
  reducerPath: "currencyApi",
  baseQuery,
  endpoints: (builder) => ({
    getExchangeRate: builder.query({
      query: ({ base = "USD", symbols = "AZN" }) =>
        `https://api.exchangerate.host/latest?base=${base}&symbols=${symbols}`,
    }),
  }),
});

export const { useGetExchangeRateQuery } = currencyApi;
